module.exports = __webpack_public_path__ + "static/img/M-1.aafd2c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mga/M-1.png
// module id = 0UzR
// module chunks = 0